export default Object.freeze({
  NONE: null,
  ANONYMOUS: 'anonymous',
  USER: 'user',
  ADMIN: 'admin',
  SUPERADMIN: 'superadmin'
})
